import {
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NavigationComponent } from './navigation/navigation.component';
import { FooterComponent } from './footer/footer.component';
import { GoalsComponent } from './goals/goals.component';
import { GoalsChartComponent } from './goals-chart/goals-chart.component';
import { TotalCaloricAndMacroIntakeComponent } from './total-caloric-and-macro-intake/total-caloric-and-macro-intake.component';
import { MealCardComponent } from './meal-card/meal-card.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MealCardTabsComponent } from './meal-card-tabs/meal-card-tabs.component';
import { MealComponent } from './meal/meal.component';
import { AddFoodToPlanComponent } from './add-food-to-plan/add-food-to-plan.component';
import { CreateNewFoodComponent } from './create-new-food/create-new-food.component';
import { HomeAuthenticatedComponent } from './home-authenticated/home-authenticated.component';
import { HomeUnauthenticatedComponent } from './home-unauthenticated/home-unauthenticated.component';
import { RegisterComponent } from './register/register.component';
import { LoginComponent } from './login/login.component';
import { ProfileComponent } from './profile/profile.component';
import { CreateRoleComponent } from './create-role/create-role.component';
import { ListRolesComponent } from './list-roles/list-roles.component';
import { EditRoleComponent } from './edit-role/edit-role.component';
import { EditUsersInRoleComponent } from './edit-users-in-role/edit-users-in-role.component';
import { CookiesNotificationComponent } from './cookies-notification/cookies-notification.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { ContactComponent } from './contact/contact.component';
import { PasswordResetComponent } from './password-reset/password-reset.component';
import { HelpCenterComponent } from './help-center/help-center.component';
import { RetrieveMyDataComponent } from './retrieve-my-data/retrieve-my-data.component';
import { PrivacyQuestionsComponent } from './privacy-questions/privacy-questions.component';

@NgModule({
  declarations: [
    AppComponent,
    NavigationComponent,
    FooterComponent,
    GoalsComponent,
    GoalsChartComponent,
    TotalCaloricAndMacroIntakeComponent,
    MealCardComponent,
    MealCardTabsComponent,
    MealComponent,
    AddFoodToPlanComponent,
    CreateNewFoodComponent,
    HomeAuthenticatedComponent,
    HomeUnauthenticatedComponent,
    RegisterComponent,
    LoginComponent,
    ProfileComponent,
    CreateRoleComponent,
    ListRolesComponent,
    EditRoleComponent,
    EditUsersInRoleComponent,
    CookiesNotificationComponent,
    PrivacyPolicyComponent,
    ContactComponent,
    PasswordResetComponent,
    HelpCenterComponent,
    RetrieveMyDataComponent,
    PrivacyQuestionsComponent,
  ],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
  ],
  providers: [
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppModule { }
